import { render, staticRenderFns } from "./bad-tag-modal.vue?vue&type=template&id=f635d958&scoped=true&"
import script from "./bad-tag-modal.vue?vue&type=script&lang=js&"
export * from "./bad-tag-modal.vue?vue&type=script&lang=js&"
import style0 from "./bad-tag-modal.vue?vue&type=style&index=0&id=f635d958&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f635d958",
  null
  
)

component.options.__file = "bad-tag-modal.vue"
export default component.exports